<template>
    <div v-if="properties && properties.length">
      <h2 class="text-base-content text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">
        {{ title }}
      </h2>
      <div class="grid grid-cols-[repeat(auto-fit,minmax(158px,1fr))] gap-3 p-4">
        <PropertyCard
          v-for="(property, index) in properties"
          :key="index"
          :property="property"
          :big="false"
        />
      </div>
    </div>
  </template>
  
  <script>
  import PropertyCard from '@/components/common/PropertyCard.vue'
  
  export default {
    name: 'PropertySection',
    components: { PropertyCard },
    props: {
      title: {
        type: String,
        required: true
      },
      properties: {
        type: Array,
        required: true
      }
    }
  }
  </script>